import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { ContentTemplate, TitleHeader } from 'web-library';
import ExamSummary from '../../modules/examRegistration/components/ExamSummary';
import ResitSummary from '../../modules/resit/components/@candidate/ResitSummary';
import ViewDetails from '../../modules/subject/components/ViewDetails';
import CoordinatorAppealSummary from '../appeal/CoordinatorAppealSummary';

interface ExamRegistrationType {
  examRegistrationType: string;
}

const Summary = () => {
  const { t } = useTranslation();
  let title = t('resit->>ResitRoute.Resit registration');
  const { examRegistrationType } = useParams<ExamRegistrationType>();
  if (
    examRegistrationType === 'exam-registration' ||
    examRegistrationType === 'amendment-registration'
  ) {
    title = t('exam->>PaymentLink.ExamRegistrationPaymentSummary');
  }

  if (examRegistrationType === 'appeal-registration') {
    title = t('exam->>PaymentLink.AppealForReviewOfResultsDetails');
  }

  const resitLabel = 'resit';
  const appealRegistrationLabel = 'appeal-registration';
  const examRegistrationLabel = 'exam-registration';
  const amendmentRegistrationLabel = 'amendment-registration';

  return (
    <>
      <TitleHeader title={title} />

      {examRegistrationType === resitLabel && (
        <ContentTemplate type="full">
          <ResitSummary />
        </ContentTemplate>
      )}
      {examRegistrationType === appealRegistrationLabel && (
        <CoordinatorAppealSummary isPaymentLink />
      )}
      {examRegistrationType === examRegistrationLabel && <ExamSummary isPaymentLink />}
      {examRegistrationType === amendmentRegistrationLabel && <ViewDetails isPaymentLink />}
    </>
  );
};

export default Summary;
